import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/l10n/fr.js'

export default class FlatpickrController extends Controller {
  connect() {
    flatpickr.localize(flatpickr.l10ns.fr);

    flatpickr(this.element, {
      dateFormat: 'd/m/Y',
      disableMobile: true,
      allowInput: true,
      parseDate: (datestr, format) => {
        const parsed = flatpickr.parseDate(datestr, format);
        if(parsed === undefined) {
          this.element.classList.add('border-danger');
        }
        return parsed;
      },
    });
  }
}
